var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h582v402H-1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFB",
    d: "M7.603 12.521L1 6.468 7.603.415l1.014 1.106L3.22 6.468l5.397 4.947-1.014 1.106z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFB",
    d: "M1.965 5.718h16v1.5h-16v-1.5z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }))));
}

export default SvgArrowLeft;